import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ContextLibraryDestroyInput, ContextLibraryDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = ContextLibraryDestroyInput;
type TData = ContextLibraryDestroyPayload;

export const useContextLibraryDelete = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation contextLibraryFileDestroy($input: ContextLibraryDestroyInput!) {
      contextLibraryFileDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
